'use client';

import { useEffect, useState } from 'react';
import Image, { getImageProps } from 'next/image';

import { SafeImageProps } from '@/widgets/SafeImage/models';

export const SafeImage = ({ src, alt, fallback, className, fill, mobileSrc, mobileMedia = '(max-width: 767px)', ...props }: SafeImageProps) => {
    const [imgSrc, setImgSrc] = useState(src);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        setImgSrc(src);
        setLoaded(false);
    }, [src]);

    const mobileImageProps = mobileSrc && imgSrc !== fallback ? getImageProps({ ...props, fill, src: mobileSrc, alt }).props : undefined;

    return (
        <span className={fill ? 'absolute inset-0 block' : 'relative inline-block leading-none'}>
            {!loaded && <span className='absolute inset-0 z-[1] animate-pulse rounded-lg bg-gray-200' aria-hidden />}
            <picture>
                {mobileImageProps && (
                    <source media={mobileMedia} srcSet={mobileImageProps.srcSet ?? mobileImageProps.src} sizes={mobileImageProps.sizes} />
                )}
                <Image
                    {...props}
                    fill={fill}
                    src={imgSrc}
                    alt={alt}
                    onLoad={() => setLoaded(true)}
                    onError={() => setImgSrc(fallback)}
                    className={`${className ?? ''} transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'}`}
                />
            </picture>
        </span>
    );
};
